import MenuOption from "./MenuOption";


let houseIcon = <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="#fff" viewBox="-2 0 21 21"><path fill-rule="evenodd" d="M14.875 18.013h-3.188v-4H5.314v4H2.124V8.799l6.364-5.99 6.386 6.01v9.194Zm2.07-10L8.47 0 0 7.999v12.014h7.438v-4h2.125v4H17v-12h-.055Z"/></svg>
let squareIcon = <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="#fff"  viewBox="0 0 256 256"><path d="M120 48v64a7.995 7.995 0 0 1-8 8H48a7.995 7.995 0 0 1-8-8V48a7.995 7.995 0 0 1 8-8h64a7.995 7.995 0 0 1 8 8Zm88-8h-64a7.995 7.995 0 0 0-8 8v64a7.995 7.995 0 0 0 8 8h64a7.995 7.995 0 0 0 8-8V48a7.995 7.995 0 0 0-8-8Zm-96 96H48a7.995 7.995 0 0 0-8 8v64a7.995 7.995 0 0 0 8 8h64a7.995 7.995 0 0 0 8-8v-64a7.995 7.995 0 0 0-8-8Zm96 0h-64a7.995 7.995 0 0 0-8 8v64a7.995 7.995 0 0 0 8 8h64a7.995 7.995 0 0 0 8-8v-64a7.995 7.995 0 0 0-8-8Z"/></svg>
let stackIcon = <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="#fff" viewBox="0 0 32 32"><path d="M28.608 11.246 16 2.614 3.392 11.246 16 19.877l12.608-8.631zM16 21.803 4.871 14.465 3.392 16 16 24.631 28.608 16l-1.499-1.568L16 21.803zm0 4.756L4.871 19.221l-1.479 1.535L16 29.387l12.608-8.631-1.499-1.568L16 26.559z"/></svg>

const Menu = ( {handleButtonClick} ) => {
    return (
        <div className="mt-2">
            <ul>
                <MenuOption onButtonClick={handleButtonClick} label="My Licenses" icon={squareIcon}/>
                <MenuOption onButtonClick={handleButtonClick} label="Explore" icon={stackIcon}/>
            </ul>
        </div>
    );
};

export default Menu;

